import React from 'react'
import { animated, config, useSpring } from 'react-spring'

import { Outline } from '@cinch/oxd-components/button/src'
import Panel from '@cinch/oxd-components/panel/src'

import { VehicleLabelValueListsItemItem } from '../../types'

import * as styles from './vehicle-panel.module.css'

interface VehiclePanelComponentProps {
  title?: string
  labels: VehicleLabelValueListsItemItem[]
  imageItem?: {
    value: string
  }
  action?: {
    label: string
    method: () => void
  }
}

const VehiclePanelComponent: React.FC<VehiclePanelComponentProps> = ({ title, labels, imageItem, action }) => {
  const animateIn = useSpring({
    config: config.gentle,
    from: { transform: 'translateY(-10px)', opacity: 0 },
    to: { transform: 'translateY(0px)', opacity: 1 },
  })

  const [hasImageError, setHasImageError] = React.useState(false)

  return (
    <Panel title={title} className={styles.vehiclePanel}>
      <div className={styles.information} data-testid="vehicle-panel">
        {imageItem && !hasImageError && (
          <figure data-testid="vehicle-panel__image-fig">
            <animated.img
              data-testid="vehicle-panel__image"
              style={animateIn}
              alt={'image'}
              src={imageItem.value}
              className={styles.image}
              onError={() => setHasImageError(true)}
            />
            <figcaption className={styles.caption}>Image for illustrative purposes only</figcaption>
          </figure>
        )}
        <dl data-testid="vehicle-panel__description-list">
          {labels.map((item, index) => (
            <React.Fragment key={index}>
              <dt data-testid="vehicle-panel__description-term" className={styles.dt}>
                {item.label}
              </dt>
              <dd data-testid="vehicle-panel__description-desc" className={styles.dd}>
                {item.value}
              </dd>
            </React.Fragment>
          ))}
        </dl>
        {action && (
          <Outline type="button" size="mini" onClick={action.method} data-testid="vehicle-panel__button">
            {action.label}
          </Outline>
        )}
      </div>
    </Panel>
  )
}

export default VehiclePanelComponent
